import { render } from "./ModalSelectSendMailAndZaloTemplate.vue?vue&type=template&id=63f6d40e&scoped=true"
import script from "./ModalSelectSendMailAndZaloTemplate.vue?vue&type=script&lang=js"
export * from "./ModalSelectSendMailAndZaloTemplate.vue?vue&type=script&lang=js"

import "./ModalSelectSendMailAndZaloTemplate.vue?vue&type=style&index=0&id=63f6d40e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f6d40e"]])

export default __exports__